export class Balance {
  constructor(
    public ticket: string,
    public amount: number,
    public date: Date
  ) {}
}
